import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addSuppliesCategoryAPI, addSuppliesItemAPI, consumeSuppliesItemAPI,
    suppliesCategoryListAPI, suppliesItemDetailAPI, suppliesItemListAPI,
    updateSuppliesCategoryAPI, updateSuppliesItemStockAPI
} from '../api-requests/supplies';
import {
    addSuppliesCategoryRequestError, addSuppliesCategoryRequestSuccess, addSuppliesItemRequestError,
    addSuppliesItemRequestSuccess, consumeSuppliesItemRequestError, consumeSuppliesItemRequestSuccess,
    suppliesCategoryListRequestError, suppliesCategoryListRequestSuccess, suppliesItemDetailRequestError,
    suppliesItemDetailRequestSuccess, suppliesItemListRequestError, suppliesItemListRequestSuccess,
    updateSuppliesCategoryDetailRequestError, updateSuppliesCategoryDetailRequestSuccess,
    updateSuppliesItemStockRequestError, updateSuppliesItemStockRequestSuccess
} from './supplies.action';
import { SuppliesActionTypes } from './supplies.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';
import { APP_CONSTANTS } from '../../utils/AppConstants';

function* handleUpdateSuppliesItemStockRequest({ payload }) {
    try {
        const response = yield call(updateSuppliesItemStockAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateSuppliesItemStockRequestSuccess(decryptedData))
            } else {
                yield put(updateSuppliesItemStockRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SuppliesActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateSuppliesItemStockRequestError(error.response.data))
        }
    }
}

export function* updateSuppliesItemStockReq() {
    yield takeLatest(SuppliesActionTypes.UPDATE_SUPPLIES_ITEM_STOCK_REQUEST, handleUpdateSuppliesItemStockRequest)
}

function* handleUpdateSuppliesCategoryRequest({ payload }) {
    try {
        const response = yield call(updateSuppliesCategoryAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateSuppliesCategoryDetailRequestSuccess(decryptedData))
            } else {
                yield put(updateSuppliesCategoryDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SuppliesActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateSuppliesCategoryDetailRequestError(error.response.data))
        }
    }
}

export function* updateSuppliesCategoryDetailReq() {
    yield takeLatest(SuppliesActionTypes.UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST, handleUpdateSuppliesCategoryRequest)
}

function* handleSuppliesItemListRequest({ payload }) {
    try {
        const response = yield call(suppliesItemListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(suppliesItemListRequestSuccess(decryptedData))
            } else {
                yield put(suppliesItemListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SuppliesActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(suppliesItemListRequestError(error.response.data))
        }
    }
}

export function* suppliesItemListReq() {
    yield takeLatest(SuppliesActionTypes.SUPPLIES_ITEM_LIST_REQUEST, handleSuppliesItemListRequest)
}

function* handleSuppliesItemDetailRequest({ payload }) {
    try {
        const response = yield call(suppliesItemDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(suppliesItemDetailRequestSuccess(decryptedData))
            } else {
                yield put(suppliesItemDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SuppliesActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(suppliesItemDetailRequestError(error.response.data))
        }
    }
}

export function* suppliesItemDetailReq() {
    yield takeLatest(SuppliesActionTypes.SUPPLIES_ITEM_DETAIL_REQUEST, handleSuppliesItemDetailRequest)
}

function* handleSuppliesCategoryListRequest({ payload }) {
    try {
        const response = yield call(suppliesCategoryListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(suppliesCategoryListRequestSuccess(decryptedData))
            } else {
                yield put(suppliesCategoryListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SuppliesActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(suppliesCategoryListRequestError(error.response.data))
        }
    }
}

export function* suppliesCategoryListReq() {
    yield takeLatest(SuppliesActionTypes.SUPPLIES_CATEGORY_LIST_REQUEST, handleSuppliesCategoryListRequest)
}

function* handleConsumeSuppliesItemRequest({ payload }) {
    try {
        const response = yield call(consumeSuppliesItemAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(consumeSuppliesItemRequestSuccess(decryptedData))
            } else {
                yield put(consumeSuppliesItemRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SuppliesActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(consumeSuppliesItemRequestError(error.response.data))
        }
    }
}

export function* consumeSuppliesItemReq() {
    yield takeLatest(SuppliesActionTypes.CONSUME_SUPPLIES_ITEM_REQUEST, handleConsumeSuppliesItemRequest)
}

function* handleAddSuppliesItemRequest({ payload }) {
    try {
        const response = yield call(addSuppliesItemAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addSuppliesItemRequestSuccess(decryptedData))
            } else {
                yield put(addSuppliesItemRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SuppliesActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(addSuppliesItemRequestError(error.response.data))
        }
    }
}

export function* addSuppliesItemReq() {
    yield takeLatest(SuppliesActionTypes.ADD_SUPPLIES_ITEM_REQUEST, handleAddSuppliesItemRequest)
}

function* handleAddSuppliesCategoryRequest({ payload }) {
    try {
        const response = yield call(addSuppliesCategoryAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addSuppliesCategoryRequestSuccess(decryptedData))
            } else {
                yield put(addSuppliesCategoryRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SuppliesActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(addSuppliesCategoryRequestError(error.response.data))
        }
    }
}

export function* addSuppliesCategoryReq() {
    yield takeLatest(SuppliesActionTypes.ADD_SUPPLIES_CATEGORY_REQUEST, handleAddSuppliesCategoryRequest)
}